<script setup>
import { computed } from  'vue'
import ContentHeader from '@/Components/Content/Header/index.vue'; 
import Button from '@/Components/Button.vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
  course: {
    type: Object,
    required: true,
  },
});

const page = usePage();
const context = computed(() => page.props?.context);
const enquiryEnabled = context.value?.enquiry_enabled ?? false;

const webAddress = computed(() => {
  let url = props.course?.sites?.[0]?.course_web_address;
  if (!url) {
    url = props.course?.organisation?.web_address;
  }
  if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
    url = 'https://' + url;
  }
  return url;
});
</script>

<template>
  <ContentHeader
    :image-set="course.organisation.logos"
    :logo-alt-text="course.organisation.name"
  >
    <template #title>
      {{ course.name }}
    </template>
    <template #subtitle>
      <a :href="`/provider/${course.organisation.slug}/${course.organisation.id}`">
        {{ course.organisation.name }}
      </a>
    </template>
    <template #actions>
      <li v-if="enquiryEnabled" class="h-fit mb-0">
        <Button
          class="w-full"
          variant="primary"
          type="link"
          :aria-label="`Enquire about ${course.name}`"
          :link="`/course/${course.slug}/${course.id}/enquiry`"
        >
          Enquire
        </Button>
      </li>
      <li v-if="webAddress" class="h-fit mb-0">
        <Button
          class="w-full"
          variant="secondary"
          type="link"
          :link="webAddress"
          :external="true"
          :link-data="course.organisation.name"
        >
          Visit website
        </Button>
      </li>
    </template>
  </ContentHeader>
</template>
